import axios from 'axios';

const api = axios.create({
  baseURL: `https://brainduc.sistematutor.com.br/api/`,
  headers: {
    'Content-Type': 'application/json',
  },
}); 

// api.interceptors.response.use(
//   response => {
//     return response;
//   },
//   async error => {
//     const status = error.response ? error.response.status : null;

//     try {
//       switch(status) {
//         case 400:
//         case 401:
//         case 403:
//           logout();
//           break;
//         case 409:
//           return;
//       }

//       return Promise.reject(error);
//     } catch (err) {
//       console.error('Erro no interceptor:', err);
//       return Promise.reject(err);
//     }
//   }
// );

// function logout() {
//   window.location.href = "/login";
//   store.commit('clearAuth');
// }

export default api;
